module.exports = __webpack_public_path__ + "mo/img/consultant.12864f8c.webp";